import { OrderData } from './order-data';

export class LFOrderList {
  public data: OrderData[] = [];
  public projectId = '';
}
